import MaskToggle from './MaskToggle';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { Camera, X, TriangleAlert } from 'lucide-react';
import { uid, compressImage } from '../lib/model';
import { SEVS } from '../lib/maint';

export const SeverityPick = ({ t, value, onChange, prefix }) => (
  <div className="sev-pick" data-testid={`${prefix}-severity`}>
    {SEVS.map((k) => <button key={k} className={`chip seg sev-${k} ${(value || 'medium') === k ? 'on' : ''}`} data-testid={`${prefix}-severity-${k}`} onClick={() => onChange(k)}>{t['sev_' + k]}</button>)}
  </div>
);

// after a leak is placed: open camera right away, keep a prompt as fallback / cancel
export default function LeakPhotoPrompt({ t, net, fittings = [] }) {
  const [fid, setFid] = useState(null);
  const inRef = useRef(null);
  const seen = useRef(null);
  const last = net.lastFit;
  useEffect(() => {
    if (!last) return;
    const f = fittings.find((x) => x.id === last.id);
    if (f?.type !== 'leak' || seen.current === last.id) return;
    seen.current = last.id;
    setFid(last.id);
    try { inRef.current?.click(); } catch { /* needs a tap, prompt stays */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [last]);
  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file || !fid) return;
    const item = { id: uid('ph'), kind: 'photo', caption: t.leakPhotoCap, leakProof: true, createdAt: Date.now(), ...(await compressImage(file)) };
    net.updateFitting(fid, (x) => ({ media: [item, ...(x.media || [])] }));
    toast.success(t.leakPhotoSaved);
    setFid(null);
  };
  return (
    <>
      <input ref={inRef} type="file" accept="image/*" capture="environment" hidden data-testid="leak-photo-input" onChange={onFile} />
      {fid && (
        <div className="leak-prompt mask" data-testid="leak-photo-prompt">
          <MaskToggle t={t} id="leak-prompt" />
          <TriangleAlert size={18} />
          <span>{t.leakPhotoAsk}</span>
          <SeverityPick t={t} prefix="leak-prompt" value={fittings.find((x) => x.id === fid)?.severity} onChange={(severity) => net.updateFitting(fid, { severity })} />
          <button className="btn btn-red btn-sm" data-testid="leak-photo-take-btn" onClick={() => inRef.current.click()}><Camera size={15} /> {t.leakPhotoBtn}</button>
          <button className="icon-btn" data-testid="leak-photo-skip-btn" aria-label={t.leakPhotoSkip} title={t.leakPhotoSkip} onClick={() => setFid(null)}><X size={15} /></button>
        </div>
      )}
    </>
  );
}
